/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1BannerId200,
  GetApiV1BannerId401,
  GetApiV1BannerId404,
  GetApiV1BannerId500,
  GetApiV1BannerIdPathParams,
  GetApiV1BannerIdQueryResponse,
} from "../../types/bannerRegistroController/GetApiV1BannerId.ts";
import { bannerViewModelSchema } from "../bannerViewModelSchema.ts";

export const getApiV1BannerIdPathParamsSchema = z.object({
  id: z.coerce.number().int(),
}) as unknown as ToZod<GetApiV1BannerIdPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1BannerId200Schema = z.lazy(
  () => bannerViewModelSchema,
) as unknown as ToZod<GetApiV1BannerId200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1BannerId401Schema =
  z.any() as unknown as ToZod<GetApiV1BannerId401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const getApiV1BannerId404Schema =
  z.any() as unknown as ToZod<GetApiV1BannerId404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1BannerId500Schema =
  z.any() as unknown as ToZod<GetApiV1BannerId500>;

export const getApiV1BannerIdQueryResponseSchema = z.lazy(
  () => getApiV1BannerId200Schema,
) as unknown as ToZod<GetApiV1BannerIdQueryResponse>;
